export const formatAward = (award) => {
  if (typeof award === 'string') {
    return award
  }
  const { outcome, awardTypeName, description, year } = award
  return `(${outcome === 'nom' ? 'Nom' : 'Won'}) - ${awardTypeName} - ${description} ${
    year ? `(${year})` : ''
  }`
}
